import { Provider } from "react-redux";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
// theme
import ThemeComponent from "theme/theme";
// store
import store from "store";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <Provider store={store}>
    <ThemeComponent>
      <App />
    </ThemeComponent>
  </Provider>
);

reportWebVitals();
